// Module
var code = "<div class=\"tabulator-footer\"> <div class=\"message pull-left\"> {{ $ctrl.tab.loading ? ('common.loading' | translate) : $ctrl.tab.message }} </div> </div> ";
// Exports
export default code;